import { DatabaseProviderType } from './../enums/database-provider-type.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDatabaseProvider'
})
export class ToDatabaseProviderPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let text = '';
    switch (value) {
      case 2: text = DatabaseProviderType[DatabaseProviderType.Oracle]; break;
      case 3: text = DatabaseProviderType[DatabaseProviderType.Postgres]; break;
      case 4: text = DatabaseProviderType[DatabaseProviderType.MySQL]; break;
      default: text = DatabaseProviderType[DatabaseProviderType.SQLServer]; break;
    }

    return text;
  }

}
